import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiKey } from '../../contexts/ApiKeyContext';
import { Tournament, TStateEnum } from '../../models/Tournament';
import { postTournament } from '../../services/TournamentService';
import { getDefaultTournamentStart } from '../../utils/Dates';

interface AddTournamentDialogProps {
  tenantId: number;
  onClose: () => void;
}

export const AddTournamentDialog = ({ tenantId, onClose }: AddTournamentDialogProps) => {
  const { apiKey } = useApiKey();
  const navigate = useNavigate();
  const [tournament, setTournament] = useState<Tournament>({
    id: 0,
    name: '',
    phases: [],
    tenantId: tenantId,
    startDate: getDefaultTournamentStart().toISOString(),
    state: TStateEnum.Draft,
  });

  const updateTournamentName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTournament((tournament) => {
      return { ...tournament, name: event.target.value };
    });
  };

  const saveAndGoToEditor = () => {
    postTournament(apiKey, tournament).then((result) => {
      navigate(`/edit-tournament/${result.id}`);
    });
  };

  return (
    <Dialog onClose={onClose} fullWidth maxWidth={'sm'} open={true}>
      <DialogTitle sx={{ m: 0, p: 2 }}>Nowy turniej</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <TextField label="Nazwa turnieju" fullWidth value={tournament.name} onChange={updateTournamentName} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={saveAndGoToEditor} disabled={tournament.name.trim() === ''}>
          DODAJ
        </Button>
      </DialogActions>
    </Dialog>
  );
};
